import * as React from "react";
import { DataGrid } from "@mui/x-data-grid"; // Import DataGrid
import Paper from "@mui/material/Paper";

const columns = [
  { field: "sno", headerName: "S.no", width: 100 },
  { field: "university", headerName: "University", width: 200 },
  { field: "course", headerName: "Course", width: 200 },
  {
    field: "tteacher",
    headerName: "Total Teacher",
    width: 150,
    type: "number",
    headerAlign: "left",
    align: 'left'
  },
  { field: "engStudent", headerName: "Engaged Students", width: 180 },
  { field: "sucCall", headerName: "Successful Calls", width: 150 },
  { field: "srmgs", headerName: "Send/Received Messages", width: 200 },
  { field: "avgTime", headerName: "Avg. Time per Call", width: 180 },
  // { field: "type", headerName: "Type", width: 120 },
];

const rows = [
  {
    id: 1,
    sno: "1",
    university: "Harvard University",
    course: "Computer Science Year 1",
    tteacher: 25,
    engStudent: 230,
    sucCall: 180,
    srmgs: 320,
    avgTime: "15 mins",
    type: "Audio",
  },
  {
    id: 2,
    sno: "2",
    university: "Stanford University",
    course: "Mathematics Year 3",
    tteacher: 30,
    engStudent: 280,
    sucCall: 230,
    srmgs: 250,
    avgTime: "21 mins",
    type: "Video",
  },
  {
    id: 3,
    sno: "3",
    university: "MIT",
    course: "Physics Year 2",
    tteacher: 18,
    engStudent: 130,
    sucCall: 110,
    srmgs: 180,
    avgTime: "14 mins",
    type: "Video",
  },
  {
    id: 4,
    sno: "4",
    university: "University of Oxford",
    course: "Computer Science Year 2",
    tteacher: 24,
    engStudent: 160,
    sucCall: 150,
    srmgs: 220,
    avgTime: "17 mins",
    type: "Audio",
  },
  {
    id: 5,
    sno: "5",
    university: "University of Cambridge",
    course: "Mathematics Year 1",
    tteacher: 43,
    engStudent: 220,
    sucCall: 200,
    srmgs: 130,
    avgTime: "12 mins",
    type: "Video",
  },
  {
    id: 6,
    sno: "6",
    university: "Yale University",
    course: "Physics Year 3",
    tteacher: 33,
    engStudent: 260,
    sucCall: 250,
    srmgs: 180,
    avgTime: "18 mins",
    type: "Video",
  },
  {
    id: 7,
    sno: "7",
    university: "Princeton University",
    course: "Chemistry Year 2",
    tteacher: 24,
    engStudent: 170,
    sucCall: 150,
    srmgs: 230,
    avgTime: "20 mins",
    type: "Audio",
  },
  {
    id: 8,
    sno: "8",
    university: "Harvard University",
    course: "Biology Year 1",
    tteacher: 54,
    engStudent: 290,
    sucCall: 260,
    srmgs: 140,
    avgTime: "11 mins",
    type: "Video",
  },
  {
    id: 9,
    sno: "9",
    university: "Stanford University",
    course: "Engineering Year 1",
    tteacher: 33,
    engStudent: 110,
    sucCall: 100,
    srmgs: 220,
    avgTime: "22 mins",
    type: "Audio",
  },
  {
    id: 10,
    sno: "10",
    university: "Princeton University",
    course: "Computer Science Year 3",
    tteacher: 22,
    engStudent: 130,
    sucCall: 120,
    srmgs: 290,
    avgTime: "18 mins",
    type: "Video",
  },
];

export default function DataGridTable() {
  return (
    <Paper sx={{ width: "100%", overflow: "hidden", boxShadow: 'none' }}>
      <div style={{ width: "100%" }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5, 10, 25]}
          pagination
          autoHeight // This prop allows the grid to automatically adjust its height based on the number of rows
          sx={{
            fontFamily: "Nunito Sans, sans-serif",
            fontSize: "14px",
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#ebebeb",
              color: "#000",
              fontWeight: "bold",
              fontSize: "14px",
              padding: "6px",
              fontFamily: "Nunito Sans, sans-serif",
            },
            "& .MuiDataGrid-cell": {
              padding: "6px",
              fontFamily: "Nunito Sans, sans-serif",
              fontSize: "14px",
            },
            "& .MuiDataGrid-row:hover": {
              backgroundColor: "#f5f5f5",
            },
          }}
        />
      </div>
    </Paper>
  );
}
